import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const PropertyLicencesFilter = ({
    propertyLicences = [],
    loading = false,
    filters,
    restoreFilterValues,
    onChangeValue = null,
}) => (
    <Field
        className='--customWidth --propertyLicence'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='propertyLicences'
        options={propertyLicences}
        placeholder='Property licence'
        search
        onChangeValue={onChangeValue}
        setValue={restoreFilterValues(filters, 'propertyLicences')}
    />
);

PropertyLicencesFilter.propTypes = {
    propertyLicences: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
};
